var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: _vm.config.width,
        "append-to-body": true,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.config.data
        ? _c(
            "el-form",
            {
              ref: "form",
              staticClass: "mt10",
              attrs: {
                model: _vm.rules,
                "label-width": "90px",
                rules: _vm.rule,
              },
            },
            [
              _c(
                "el-form-item",
                { staticClass: "assess-item", attrs: { label: "指标名称:" } },
                [
                  _c(
                    "div",
                    { staticClass: "info" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.config.data.name) +
                          "\n        "
                      ),
                      _c("font", { attrs: { color: "#f90" } }, [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.config.types == 1
                                ? "满分" + _vm.config.data.ratio + "分"
                                : "权重" + _vm.config.data.ratio + "%"
                            ) +
                            ")"
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "6px" },
                  attrs: { label: "指标说明:" },
                },
                [
                  _c("div", { staticClass: "info" }, [
                    _vm._v(_vm._s(_vm.config.data.content)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "完成情况:" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入完成情况",
                    },
                    model: {
                      value: _vm.config.data.finish_info,
                      callback: function ($$v) {
                        _vm.$set(_vm.config.data, "finish_info", $$v)
                      },
                      expression: "config.data.finish_info",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "assess-item",
                  attrs: {
                    label: _vm.config.types == 1 ? "自评分(分)" : "完成度(%)",
                    title:
                      _vm.config.types == 1
                        ? "最高" + _vm.config.data.ratio + "分"
                        : "最大完成度100%",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      placeholder:
                        _vm.config.types == 1
                          ? "0～" + _vm.config.data.ratio
                          : "0～100",
                      controls: false,
                      min: 0,
                      size: "small",
                      precision: 0,
                      max: _vm.config.types == 1 ? _vm.config.data.ratio : 100,
                    },
                    model: {
                      value: _vm.finishRatio,
                      callback: function ($$v) {
                        _vm.finishRatio = $$v
                      },
                      expression: "finishRatio",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.config.types == 1
                          ? "最高" + _vm.config.data.ratio + "分"
                          : "%（最高100%）"
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }